import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { RemoteDeviceSelectors } from './remote-device.selectors';

@Injectable({ providedIn: 'root' })
export class RemoteDeviceStore {
  zigbeeTopologyDeviceData$ = this.store.select(
    RemoteDeviceSelectors.getZigbeeTopologyDeviceData()
  );
  isZigbeeTopologyAvailable$ = this.store.select(RemoteDeviceSelectors.isZigbeeTopologyAvailable());
  namesInUse$ = this.store.select(RemoteDeviceSelectors.getDevicesNames());

  constructor(private store: Store) {}
}
